import React, { useRef, useState } from 'react';

import { Row, Col, Button, Input, Form as AntdForm } from 'antd';
import { CardWrapper, FormWrapper } from '../styles';
import { api } from '../../../services/api';
import { getSubDomain } from '../../../hooks/getSubDomain';
import { SelectSegmento } from '../../../components/Select';
import { UploadComponent } from '../../../components/UploadComponent';
import { IHandleSubmitProps } from '../types';
import { UploadFile } from 'antd/lib/upload/interface';
import toast from 'react-hot-toast';
import { MultiSelect } from '../../../components/MultiSelect';
import { dados } from '../../../utility/env';
import { SelectPessoa } from '../../../components/Select/SelectPessoa';
import { SelectBanco } from '../../../components/Select/SelectBanco';
import { SelectProprietario } from '../../../components/Select/SelectProprietario';
import { SelectContrato } from '../../../components/Select/SelectContrato';
import { SelectCondutor } from '../../../components/Select/SelectCondutor';
import { SelectMonitor } from '../../../components/Select/SelectMonitor';
import { SelectVeiculo } from '../../../components/Select/SelectVeiculo';
import { SelectRota } from '../../../components/Select/SelectRota';

interface IFormInitialFields {
  idRota: string;
  etapa: string;
  descricao: string;
  latitude: string;
  longitude: string;
}

interface IFormComponent {
  formType: 'put' | 'post' | 'view';
  initialFields?: IFormInitialFields;
  refetch: () => void;
  rotastrajetoId?: string;
  setModalIsOpen: (event: boolean) => void;
}

export function Form({
  formType,
  setModalIsOpen,
  refetch,
  rotastrajetoId,
  initialFields = {
    idRota: '',
    etapa: '',
    descricao: '',
    latitude: '',
    longitude: '',
  },
}: IFormComponent) {
  const [isLoading, setIsLoading] = useState(false);

  const formRef = useRef<any>(null);

  function clearFieldsAndCloseModal() {
    setModalIsOpen(false);
  }

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const foo = params.get('idRota');

  const defaultFiels = {
    ...initialFields,
    idRota: foo ? foo : initialFields.idRota,
  };

  async function handleSubmit(data: IHandleSubmitProps) {
    setIsLoading(true);

    const formData = {
      ...data,
    };

    try {
      if (formType === 'post') {
        await api.post(getSubDomain() + 'rotatrajetos', formData);
      } else {
        if (rotastrajetoId) await api.put(getSubDomain() + `rotatrajetos/${rotastrajetoId}`, formData);
      }

      setModalIsOpen(false);

      formRef.current.resetFields();
    } catch (err) {
      console.log(err);
    }

    setIsLoading(false);
    refetch();
  }

  return (
    <FormWrapper>
      <AntdForm
        name="basic"
        onFinish={handleSubmit}
        style={{ padding: '30px' }}
        layout="vertical"
        initialValues={defaultFiels}
        ref={formRef}
      >
        <Row gutter={40}>
          <Col span={12}>
            <CardWrapper type="inner" title="Informações Gerais">
              <SelectRota
                name="idRota"
                title="Rota"
                disabled={formType === 'view' ? true : foo ? true : false}
                //postUrl={getSubDomain() + "pessoas"}
                fetchUrl="rotas"
              />

              <AntdForm.Item label="Etapa" name="etapa" rules={[{ required: true, message: 'Campo obrigatório' }]}>
                <Input placeholder="" disabled={formType === 'view' ? true : false} />
              </AntdForm.Item>

              <AntdForm.Item
                label="Descrição"
                name="descricao"
                rules={[{ required: true, message: 'Campo obrigatório' }]}
              >
                <Input placeholder="" disabled={formType === 'view' ? true : false} />
              </AntdForm.Item>
            </CardWrapper>
          </Col>

          <Col span={12}>
            <CardWrapper type="inner" title="Dados Diversos">
              <AntdForm.Item
                label="Latitude"
                name="latitude"
                /* rules={[{ required: true, message: "Campo obrigatório" }]} */
              >
                <Input placeholder="" disabled={formType === 'view' ? true : false} />
              </AntdForm.Item>

              <AntdForm.Item
                label="Longitude"
                name="longitude"
                /* rules={[{ required: true, message: "Campo obrigatório" }]} */
              >
                <Input placeholder="" disabled={formType === 'view' ? true : false} />
              </AntdForm.Item>
            </CardWrapper>
          </Col>
        </Row>
        {formType == 'view' ? (
          <footer style={{ padding: '20px 30px', borderTop: '1px solid #f0f0f0' }}>
            <Button type="default" htmlType="button" onClick={clearFieldsAndCloseModal}>
              Fechar
            </Button>
          </footer>
        ) : (
          <footer style={{ padding: '20px 30px', borderTop: '1px solid #f0f0f0' }}>
            <Button type="default" htmlType="button" onClick={clearFieldsAndCloseModal}>
              Voltar
            </Button>

            <Button type="primary" htmlType="submit" loading={isLoading}>
              Salvar
            </Button>
          </footer>
        )}
      </AntdForm>
    </FormWrapper>
  );
}
